import http from "../../plugins/axios";

export default {
  list(data) {
    return http.get({
      url: "/la/admin/system/user/list",
      data,
    });
  },
  add(data) {
    return http.post({
      url: "/la/admin/system/user/add",
      data,
      dataType: "form",
    });
  },
  update(data) {
    return http.post({
      url: "/la/admin/system/user/update",
      data,
      dataType: "form",
    });
  },
  lock(data) {
    return http.post({
      url: "/la/admin/system/user/lock",
      data,
      dataType: "form",
    });
  },
  unlock(data) {
    return http.post({
      url: "/la/admin/system/user/unlock",
      data,
      dataType: "form",
    });
  },
  remove(data) {
    return http.post({
      url: "/la/admin/system/user/delete",
      data,
      dataType: "form",
    });
  },
  resetPwd(data) {
    return http.post({
      url: "/la/admin/system/user/resetPwd",
      data,
      dataType: "form",
    });
  },
  resetGoogle(data) {
    return http.post({
      url: "/la/admin/system/user/resetGoogle",
      data,
      dataType: "form",
    });
  },
  checkGoogle({ googleCode }) {
    return http.post({
      url: `/la/admin/google/check?googleCode=${googleCode}`,
    });
  },
};
